import { useState, useEffect, useRef } from "react";
import portalApi from "@/lib/portalApi";
import { usePortalAuth } from "@/context/PortalAuthContext";
import { useT } from "@/i18n";
import { ChatBubble, ChatInput, TypingIndicator, useTypingIndicator, playNotificationSound } from "@/components/shared/ChatComponents";

export default function PortalSupport() {
  const { user } = usePortalAuth();
  const t = useT();
  const p = t.portal;
  const customerId = user?.id;
  const [messages, setMessages] = useState([]);
  const endRef = useRef(null);
  const prevCountRef = useRef(0);
  const isTyping = useTypingIndicator(portalApi, customerId);

  const fetchMessages = () => {
    portalApi.get("/portal/chat").then((r) => {
      const newMsgs = r.data;
      const adminMsgs = newMsgs.filter((m) => m.sender === "admin").length;
      if (adminMsgs > prevCountRef.current && prevCountRef.current > 0) playNotificationSound();
      prevCountRef.current = adminMsgs;
      setMessages(newMsgs);
    }).catch(() => {});
  };

  useEffect(() => { fetchMessages(); const iv = setInterval(fetchMessages, 3000); return () => clearInterval(iv); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, isTyping]);

  const handleSend = async (data) => { await portalApi.post("/portal/chat", data); fetchMessages(); };

  const grouped = {};
  messages.forEach((m) => { const date = new Date(m.created_at).toLocaleDateString("pt-BR"); if (!grouped[date]) grouped[date] = []; grouped[date].push(m); });

  return (
    <div data-testid="portal-support" className="flex flex-col" style={{ height: "calc(100vh - 120px)" }}>
      <h1 className="crm-heading mb-4">{p.supportTitle}</h1>
      <div className="crm-card flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-2">
          {messages.length === 0 && (
            <div className="text-center py-16" style={{ color: "var(--crm-text-dim)" }}>
              <p className="text-sm">{p.supportEmpty}</p>
              <p className="text-xs mt-1">{p.supportTeam}</p>
            </div>
          )}
          {Object.entries(grouped).map(([date, msgs]) => (
            <div key={date}>
              <div className="flex items-center gap-3 my-4">
                <div className="flex-1 h-px" style={{ background: "var(--crm-border)" }} />
                <span className="text-[10px] font-semibold px-2" style={{ color: "var(--crm-text-dim)" }}>{date}</span>
                <div className="flex-1 h-px" style={{ background: "var(--crm-border)" }} />
              </div>
              {msgs.map((m) => (
                <ChatBubble key={m.id} msg={m} isOwn={m.sender === "customer"} ownerLabel={m.sender === "customer" ? "Você" : p.supportTitle} />
              ))}
            </div>
          ))}
          {isTyping && <TypingIndicator label={p.supportTitle} />}
          <div ref={endRef} />
        </div>
        <ChatInput onSend={handleSend} placeholder={p.typePlaceholder} apiInstance={portalApi} customerId={customerId} />
      </div>
    </div>
  );
}
